export const AUDIO_PLAYER_HEIGHT = 40
